import React from 'react';
import Logo from '../../assets/logo.jpg';

const Header = () => {
  return (
    <header className="bg-orange-50/95 backdrop-blur-sm shadow-lg border-b border-orange-200 sticky top-0 z-50">
      <div className="w-full px-6 py-2">
        <div className="flex items-center space-x-3">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img 
              src={Logo} 
              alt="Bakery Logo" 
              className="w-10 h-10 object-contain rounded-lg"
            />
            <div className="flex flex-col">
              <h1 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-600 via-pink-600 to-red-600">
                Vanilla Sky Bakehouse
              </h1>
              {/* <p className="text-xs text-gray-600 font-medium">Artisan Bakery & Café</p> */}
            </div>
          </div>
          
          {/* Navigation could be added here in the future */}
          <div className="ml-auto">
            <div className="flex items-center space-x-2">
              <span className="text-xs text-gray-500">Admin Panel</span>
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 